import './TransactionBreakdown.scss';
import Component from './TransactionBreakdown.js';
export default Component;
